<template>
  <div class="action-group">
    <dropdown
      v-if="overflowMenuVisible(layout)"
      :id="id(layout)"
      button-class="dropdown-toggle"
      container-class="action-overflow"
    >
      <span slot="label">
        <i class="af-icons af-icons-action-overflow"></i>
      </span>
      <li v-if="layout.editAction">
        <a :href="layout.editAction">{{ editLabel }}</a>
      </li>
      <li v-if="layout.deleteAction">
        <a
          :href="layout.deleteAction"
          @click.prevent.stop="deleteLayout(layout)"
        >
          {{ deleteLabel }}
        </a>
      </li>
    </dropdown>
    <div class="title">
      <span>{{ layout.name }}</span>
      <i v-if="layout.shared" class="af-icons af-icons-shared"></i>
    </div>
    <div class="actions">
      <a :href="layout.excel">{{ excelLabel }}</a>
      <a :href="layout.csv">{{ csvLabel }}</a>
    </div>
  </div>
</template>

<script>
import { Dropdown } from 'vue-bootstrap';
import $ from 'jQuery';
import tectoastr from 'tectoastr';

export default {
  components: {
    Dropdown
  },
  props: {
    listItem: {
      type: Object,
      default: () => ({}),
      validator: item =>
        item.hasOwnProperty('id') &&
        item.hasOwnProperty('name') &&
        item.hasOwnProperty('excel') &&
        item.hasOwnProperty('csv')
    },
    excelLabel: {
      type: String,
      default: 'Excel'
    },
    csvLabel: {
      type: String,
      default: 'CSV'
    },
    editLabel: {
      type: String,
      default: 'Edit'
    },
    deleteLabel: {
      type: String,
      default: 'Delete'
    }
  },
  data() {
    return {
      layout: {}
    };
  },
  mounted() {
    this.layout = this.listItem;
  },
  methods: {
    overflowMenuVisible(layout) {
      return layout.editAction || layout.deleteAction;
    },
    id(layout) {
      return 'layout-' + layout.id;
    },
    deleteLayout(layout) {
      this.$emit('deleting', layout);

      $.ajax({
        type: 'DELETE',
        url: layout.deleteAction,
        dataType: 'json'
      })
        .done(() => {
          this.$emit('deleted', layout);
        })
        .fail(error => {
          tectoastr.error(
            error.responseJSON.message ||
              document.getElementById('alerts-generic').innerHTML
          );
        });
    }
  }
};
</script>
